import { useEffect, useTransition } from "react";
import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import { notificationsImportantAtom, useNotificationsApi } from "@ryde/shared";

export const useNotificationsDrawer = () => {
  const { fetchImportant } = useNotificationsApi();
  const notificationsImportant = useRecoilValue(notificationsImportantAtom);
  const [, startTransition] = useTransition();
  const init = useEvent(async () => {
    await fetchImportant();
  });

  useEffect(() => {
    startTransition(() => {
      init();
    });
  }, [init]);

  return {
    isLoading: notificationsImportant.isLoading,
  };
};
